export const Typography = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px'
};

export const Global = {
  baseMargin: {
    S: {
      x: '10px',
      y: '10px'
    },
    M: {
      x: '20px',
      y: '10px'
    }
  }
};

export enum Color {
  white = '#fff',
  lightGrey = '#e8e8e8',
  grey100 = '#a2a2a2',
  grey200 = '#888888',
  grey300 = '#e3e3e3',
  orange = '#ff7321',
  darkBlue = '#0f172b',
  blue = '#096894',
  middleBlue = '#0f334a',
  lightBlue = '#B7CFDA',
  lighterBlue = '#E5ECF0',
  black = '#24282B',
  green = '#408764',
  red = 'red'
}

export enum FileTypeColors {
  PDF = Color.orange,
  JPG = Color.darkBlue,
  // PNG = Color.lighterBlue,
  WORD = Color.lightBlue,
  EXCEL = Color.green,
  POWERPOINT = Color.orange,
  POWER_POINT_X = Color.orange,
  LINK = Color.grey100
}

/** List of file types available */
export enum FileTypes {
  PDF = 'PDF',
  JPG = 'JPG',
  PNG = 'PNG',
  WORD = 'WORD',
  EXCEL = 'EXCEL',
  POWERPOINT = 'POWERPOINT',
  POWER_POINT_X = 'POWER_POINT_X',
  LINK = 'LINK'
}

/** List of filetypes and their fontawesome icon counterparts */
export enum FontAwesomeFileIcons {
  JPG = 'file-image',
  PNG = 'file-image',
  WORD = 'file-word',
  EXCEL = 'file-excel',
  POWERPOINT = 'file-powerpoint',
  PDF = 'file-pdf',
  LINK = 'link'
}

/** List of filetypes that can be displayed in FilePreview component. */
export const NonPreviewableFileTypes: FileTypes[] = [FileTypes.LINK];

export const ImageFileTypes: FileTypes[] = [FileTypes.PNG, FileTypes.JPG];

export enum ResponsiveSize {
  mobileS = '320px',
  mobileM = '375px',
  mobileL = '425px',
  tablet = '768px',
  laptop = '1024px',
  laptopL = '1440px',
  desktop = '1920px',
  desktopL = '2560px'
}

export enum FlexPosition {
  between = 'space-between',
  evenly = 'space-evenly',
  left = 'flex-start',
  center = 'center',
  right = 'flex-end',
  stretch = 'stretch'
}

export interface ICommonAuthenticationOptions {
  instance: string;
  redirectUri: string;
  authConfigEndpointUri: string;
}

export const AuthenticationOptions: ICommonAuthenticationOptions = {
  instance: 'https://login.microsoftonline.com/',
  redirectUri: window.location.href,
  authConfigEndpointUri: '/api/authConfig'
};

export enum APIEndpoints {
  allSolutions = 'solutions',
  materials = 'materials',
  previews = 'previews',
  /** API endpoint for Offering types and Value to Customer -fields */
  filterOptions = 'filterOptions',
  thumbnails = 'thumbnails',
  mostViewed = 'mostViewedSolutions'
}

export enum ErrorMessages {
  networkError = 'Network error. Could not load solutions.',
  solutionNotFoundError = 'Solution could not be loaded. Solution might not exist.',
  noMaterials = 'No materials related to this offering.',
  noSolutions = 'No solutions found.',
  noRelatedSolutions = 'No related solutions found.'
}

// Ratio of the angled corners. Determines the width in relation to the height.
export const CORNER_RATIO = 2 / 3;

export const POPULAR_ITEMS_COUNT = 5;

export const DEFAULT_PAGE_SIZE = 10;

export const REPORT_ROW_COUNT = 30;



// WEBPACK FOOTER //
// ./src/components/Globals/Globals.tsx